import { useState } from "react"
import { UpdateDocument } from "../../../firebase/firebase"
import Resizer from 'react-image-file-resizer'

const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      300,
      300,
      "JPEG",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "file",
      300,
      300
    );
  });

export const onImageChange = async (e, user, img) => {
    if (img) {
        const image = await resizeFile(img)
        const newUser = { ...user, ['image']: image}
        return newUser
    }
    else {
        return 'Error'
    }

}
export const onChange = (e, user) => {
    return { ...user, [e.target.name]: e.target.value }


}

export const handleCancel = (e, props) => {
    props.history.push('/profile')
}

export const handleSubmit = async (e, user, changedImage) => {
    e.preventDefault()


    try {
        
        let userToUpload = { ...user }

        if (changedImage === true) {
            userToUpload.imagePath = `/users/${userToUpload.firstName + userToUpload.lastName + userToUpload.id}`
        }


        return await UpdateDocument('users', userToUpload, changedImage)
        


    }

    catch (e) {
        alert(`Error " ${e.message}`)
        console.log('erro')

    }
    
}
